
let utilsObj = {
    /**
     * [getUUID 获取uuid]
     * @return {[type]} [description]
     */
    getUUID: function  () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16);
        });
    },

    /**
     * 邮箱
     * @param {*} s
     */
    isEmail: function (s) {
        return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s);
    },

    /**
     * 手机号码
     * @param {*} s
     */
    isMobile: function (s) {
        return /^1(3|4|5|6|7|8|9)\d{9}$/.test(s);
    },

    /**
     * 电话号码
     * @param {*} s
     */
    isPhone: function (s) {
        return /^([0-9]{3, 4}-)?[0-9]{7,8}$/.test(s);
    },

    /**
     * URL地址
     * @param {*} s
     */
    isURL: function (s) {
        return /^http[s]?:\/\/.*/.test(s);
    },

    /**
     * 树形数据转换
     * @param {*} data
     * @param {*} id
     * @param {*} pid
     */
    treeDataTranslate: function (data, id = 'id', pid = 'parentId') {
        var res = [];
        var temp = {};

        for (var i = 0; i < data.length; i++) {
            temp[data[i][id]] = data[i];
        }
        for (var k = 0; k < data.length; k++) {
            if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
                if (!temp[data[k][pid]]['children']) {
                    temp[data[k][pid]]['children'] = [];
                }
                if (!temp[data[k][pid]]['_level']) {
                    temp[data[k][pid]]['_level'] = 1;
                }
                data[k]['_level'] = temp[data[k][pid]]._level + 1;
                temp[data[k][pid]]['children'].push(data[k]);
            } else {
                res.push(data[k]);
            }
        }
        return res;
    },

    /**
     * [isNumberLetters 匹配16数字或者字母]
     * @return {Boolean} [description]
     */
    is16NumberLetters (s) {
        return /^[A-Za-z0-9]{16}$/.test(s);
    },

    /**
     * [isNumberLetters 匹配17数字或者字母]
     * @return {Boolean} [description]
     */
    is17NumberLetters (s) {
        return /^[A-Za-z0-9]{17}$/.test(s);
    },

    /**
     * [isNumberLetters 匹配6数字或者字母]
     * @return {Boolean} [description]
     */
    is6NumberLetters (s) {
        return /^[A-Za-z0-9]{6}$/.test(s);
    },

    /**
     * [is6Number 匹配6位数字]
     * @param  {[type]} s [description]
     * @return {[type]}   [description]
     */
    is6Number (s) {
        return /^\d{6}$/.test(s);
    },

    /**
     * [is6Number 匹配16位数字]
     * @param  {[type]} s [description]
     * @return {[type]}   [description]
     */
    is16Number (s) {
        return /^\d{16}$/.test(s);
    }

};


export default{
    utilsObj
};



// WEBPACK FOOTER //
// ./src/common/js/utils.js